import { useQuery } from "@tanstack/react-query";
import { gqlReq } from "~/libs/gql";
import { useVenueId } from "~/store";
import { GetOperationalNotificationsDocument } from "~/types/__generated/gql/graphql";

void (
	/* GraphQL */ `
		query GetOperationalNotifications {
			getOperationalNotifications {
				_id
				created_at
				updated_at
				content
				location
				kind
				_temp_order {
					_payment_amount
					_payment_currency
					_is_payment_approved
					_order_index
					failure_reason
				}
				_location {
					_id
					name
				}
			}
		}
	`
);

export const getOperationalNotificationsQueryKey = () => [
	"getOperationalNotifications",
];

export const useGetOperationalNotifications = () => {
	const venueId = useVenueId();

	return useQuery({
		enabled: !!venueId,
		queryKey: getOperationalNotificationsQueryKey(),
		queryFn: ({ signal }) =>
			gqlReq({
				document: GetOperationalNotificationsDocument,
				signal,
			}),
	});
};
